import { ConfigProvider, Layout, Menu, MenuProps } from 'antd'
import { useState, useEffect, useMemo, CSSProperties } from 'react'
import clsx from 'clsx'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import useGlobalStore from '@/store/useGlobalStore'
import IoncSysCollapse from '@/components/icon/sysCollapse'
import IoncSysExpand from '@/components/icon/sysExpand'
import { DefaultOpenKeys, HeaderPathMap, SelectedKeysMap, SliderWidth } from '@/config'
import { getDefaultOpenKeys } from '@/utils/help'
import { getStorage, isNotEmpty } from '@/utils/tools'
import styles from './index.module.less'
import { isDebugMode } from '@/utils/syetem'
import { MenuEnum } from '@/config/enum'

type MenuItem = Required<MenuProps>['items'][number]
const { Sider, Content } = Layout

const LayoutMenu = () => {
  const [menuData, setMenuData] = useState<MenuItem[]>([])
  const { pathname } = useLocation()
  const {
    collapsed,
    systemKey,
    tenantId: globalTenantId,
    menuKeysMap,
    basicConfigInfo,
    setCollapsed,
  } = useGlobalStore(s => ({
    collapsed: s.collapsed,
    systemKey: s.systemKey,
    tenantId: s.tenantId,
    menuKeysMap: s.menuKeysMap,
    basicConfigInfo: s.basicConfigInfo,
    setCollapsed: s.setCollapsed,
  }))

  // const systemName = useMemo(() => {
  //   return MenuEnum[systemKey]
  // }, [systemKey])


  const [openKeys, setOpenKeys] = useState([])
  const tenantId = getStorage('tenantId') || ''
  const curMenulist = menuKeysMap[systemKey] || []

  const rootSubmenuKeys = curMenulist?.map(item => item.key) || []

  // 当前路由菜单高亮
  const selectedLeftMenuKey = SelectedKeysMap[`${pathname}`] || '' // 默认每个路由都有对应key值

  // console.log("menuData",menuData)
  // 处理后端 menu data
  const transformData = (data: any[]): MenuItem[] =>
    data.map(item => {
      if (item?.children) {
        return {
          popupClassName: styles.popupMenu,
          key: item.key,
          icon: item.icon,
          label: item.title,
          children: transformData(item.children),
        }
      }
      if (item?.onClick) {
        return {
          key: item.key,
          icon: item.icon,
          label: item.title,
          onClick: item.onClick,
        }
      }
      return {
        key: item.key,
        icon: item.icon,
        label: <Link to={`${item.key}`}>{item.title}</Link>,
      }
    })

  useEffect(() => {
    if (!selectedLeftMenuKey) return
    if (menuData.length) {
      // 刷新页面时获取当前子菜单的父菜单key值
      const urlOpenKeys = getDefaultOpenKeys(menuData, selectedLeftMenuKey)
      if (urlOpenKeys[0] !== '') {
        setOpenKeys(urlOpenKeys)
      }
    }
  }, [menuData, selectedLeftMenuKey])

  useEffect(() => {
    if (!tenantId) return
    let listData = curMenulist
    // if (tenantId.startsWith('U')) {
    //   listData = personMenuList
    // }
    if (isNotEmpty(basicConfigInfo)) {
      // 处理超管和默认企业的权限
      // meta: {
      //   auth: {
      //     isSuperAdmin: true,
      //     isDefaultEpid: true
      //   }
      // },
      listData = listData.filter(item => {
        const { auth = {} } = item.meta || {}
        // if (isDebugMode()) return true; // 开发模式，都放开
        // Initialize flag as true
        let isAllowed = true;

        // Check superAdmin permission if it exists
        if ('isSuperAdmin' in auth) {
          isAllowed = isAllowed && (auth.isSuperAdmin === basicConfigInfo.isSuperAdmin);
        }

        // Check defaultEpid permission if it exists
        if ('isDefaultEpid' in auth) {
          isAllowed = isAllowed && (auth.isDefaultEpid === basicConfigInfo.isDefaultEpid);
        }

        return isAllowed;
      })
    }
    const newListData = listData.filter(i => i.children?.length !== 0)
    const newMenuData = transformData(newListData)
    setMenuData(newMenuData)
  }, [tenantId, JSON.stringify(curMenulist), JSON.stringify(basicConfigInfo)])

  // 只展开当前父级菜单,点击菜单，收起其他展开的所有菜单，保持菜单聚焦简洁。
  const onOpenChange: MenuProps['onOpenChange'] = keys => {
    const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1)
    if (rootSubmenuKeys.indexOf(latestOpenKey!) === -1) {
      setOpenKeys(keys)
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : [])
    }
  }

  // 是否是作业中心
  // const isZyzxMenu = curHeaderMenuKey === 'zyzx'

  // 宽度
  // const siderWidth = isZyzxMenu ? 0 : SliderWidth

  // slider style
  const siderStyle: CSSProperties = { position: 'fixed', minWidth: 0 }
  // const siderStyle: any = useMemo(() => {
  //   if (isZyzxMenu) {
  //     // 作业中心隐藏菜单
  //     return { position: 'fixed', minWidth: 0 }
  //   }
  //   return {
  //     position: ' fixed',
  //   }
  // }, [curHeaderMenuKey])

  // const sliderHiddenClassName = isZyzxMenu ? styles['sliderHidden'] : ''
  // console.log("menuData",menuKeysMap)
  return (
    <ConfigProvider
      theme={{
        components: {
          Menu: {
            borderRadius: 0,
            radiusSubMenuItem: 0,
            radiusItem: 0,
          },
        },
      }}
    >
      <div className={styles.container}>
        <Sider
          theme='light'
          style={siderStyle}
          className={clsx(styles.sider)}
          trigger={null}
          collapsible
          collapsed={collapsed}
          width={SliderWidth}
        >
          <div style={{ flex: '1 1 0%', overflow: 'hidden auto' }}>
            {/* 展示当前主模块 */}
            {/* <div className={styles.mainModule}>
              {systemName}
            </div> */}
            <Menu
              mode='inline'
              onOpenChange={onOpenChange}
              defaultOpenKeys={[DefaultOpenKeys]}
              openKeys={openKeys}
              items={menuData}
              selectedKeys={[selectedLeftMenuKey]}
              triggerSubMenuAction={collapsed ? 'hover' : 'click'}
            />
          </div>
          {/* 收起按钮 */}
          <div
            onClick={() => setCollapsed(!collapsed)}
            className={clsx(styles.sliderTrigger, { [styles.btnCollapsed]: collapsed })}
          >
            {collapsed ? <IoncSysExpand /> : <IoncSysCollapse />}
          </div>
        </Sider>
      </div>
    </ConfigProvider>
  )
}

export default LayoutMenu
